<ngx-glide type="carousel" [perView]="6" [showArrows]="false" [showBullets]="false" [gap]="0">
    <div *ngFor="let slide of slides" class="slide">
        <img src="{{ slide.img }}" alt="" width="100%">
    </div>
</ngx-glide>
